import React from 'react';
import classNames from 'classnames/bind';
import { Checkbox, PhoneInput, Text } from '@beef/ui-kit';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { getTargetTariffType } from '@fttb/common';
import { getOrderTariffTexts } from "../../../../store/selectors/orderTariffCommon";
import { setCtn } from "../../../../../../../store/callbackRequest/slice";
import { selectUserCtn } from "../../../../../../../store/callbackRequest/selectors";
import { selectIsCheckboxChecked } from "../../../../../../../store/CheckboxAgreement/selectors";
import { setIsCheckboxChecked } from "../../../../../../../store/CheckboxAgreement/slice";
import { Captcha } from "../../../common/Captcha";
import { usePhoneInputWithMask } from "../../../../hooks/usePhoneInputWithMask";
import { selectIsCheckboxError, selectIsShowCheckbox, selectPersonalVerificationCheckboxEnable, selectShouldShowPhoneBlock } from "../../../../store/selectors/modal";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var mask = {
  mask: '_',
  format: '+7 (###) ###-####'
};
var _PhoneInputSection = function _PhoneInputSection(_ref) {
  var isAgreementChecked = _ref.isAgreementChecked,
    isCheckboxError = _ref.isCheckboxError,
    isShowCheckbox = _ref.isShowCheckbox,
    onChangePhone = _ref.onChangePhone,
    setCheckboxChecked = _ref.setCheckboxChecked,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable,
    ctn = _ref.ctn,
    _ref$texts = _ref.texts,
    phoneLabelText = _ref$texts.phoneLabelText,
    placeholderPhoneTexts = _ref$texts.placeholderPhoneTexts,
    checkboxText = _ref$texts.checkboxText,
    phoneErrorText = _ref$texts.phoneErrorText,
    tariffType = _ref.tariffType;
  var _usePhoneInputWithMas = usePhoneInputWithMask({
      ctn: ctn,
      errorText: phoneErrorText,
      setCtn: onChangePhone,
      tariffType: tariffType
    }),
    inputCntWithMask = _usePhoneInputWithMas.inputCntWithMask,
    inputError = _usePhoneInputWithMas.inputError,
    handleChangePhone = _usePhoneInputWithMas.handleChangePhone,
    validateCtn = _usePhoneInputWithMas.validateCtn;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('phone-block-wrapper'),
    "data-t-id": "AddressRequestForm-PhoneInputSection"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size5-r-s"
  }, phoneLabelText), /*#__PURE__*/React.createElement(PhoneInput, {
    autoComplete: "off",
    className: cx('container'),
    errorMessage: inputError,
    maskSettings: mask,
    name: "phone",
    onBlur: validateCtn,
    onChange: handleChangePhone,
    placeholder: placeholderPhoneTexts,
    type: "tel",
    value: inputCntWithMask
  }), /*#__PURE__*/React.createElement(Captcha, null), isShowCheckbox && isPersonalVerificationCheckboxEnable && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isAgreementChecked,
    isError: isCheckboxError,
    label: checkboxText,
    name: "selectedAgreement"
    // @ts-expect-error fix later
    ,
    onChange: setCheckboxChecked
  }));
};

// @ts-expect-error fix later todo: typing this
var mapStateToProps = function mapStateToProps(state) {
  return {
    ctn: selectUserCtn(state),
    tariffType: getTargetTariffType(state),
    shouldRender: selectShouldShowPhoneBlock(state),
    isCheckboxError: selectIsCheckboxError(state),
    isAgreementChecked: selectIsCheckboxChecked(state),
    isShowCheckbox: selectIsShowCheckbox(state),
    texts: getOrderTariffTexts(state).phoneInputTexts,
    isPersonalVerificationCheckboxEnable: selectPersonalVerificationCheckboxEnable(state)
  };
};
var mapDispatchToProps = {
  setCheckboxChecked: setIsCheckboxChecked,
  onChangePhone: setCtn
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var PhoneInputSection = compose(connector, withRenderFlag)(_PhoneInputSection);